/**
 * Define options for generic types as types, which can be specified as type
 * parameters when creating types with your generic types.  For more details,
 * see the documentation for {@link TOptions}.
 *
 * @module @sorrell/utilities/generic/option
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
import type { TOptions } from "./Option.Types.ts";
export * from "./Option.Types.ts";
